import React from 'react';
import { cn } from '@/app/_lib/utils';

/**
 * Renders a section (top-level) or div (nested) wrapper for page components.
 * Nested modules skip <section> to avoid invalid section-in-section nesting.
 */
export const ComponentSection = React.forwardRef<
  HTMLElement,
  { isNested?: boolean; children: React.ReactNode } & React.HTMLAttributes<HTMLElement>
>(({ isNested, children, className, ...props }, ref) => {
  const finalClassName = cn(className);

  if (isNested) {
    return <div ref={ref as React.Ref<HTMLDivElement>} className={finalClassName} {...props}>{children}</div>;
  }
  return <section ref={ref} className={finalClassName} {...props}>{children}</section>;
});
ComponentSection.displayName = 'ComponentSection';
